/** Réglages d'accès à l'API, tous surchargeables par variable d'environnement Vite. */

/**
 * Racine des appels. Vide par défaut : le front tape des chemins relatifs
 * (`/api/v1/...`) et c'est le proxy Vite qui les envoie sur le back. Le front
 * n'a donc jamais à connaître l'adresse du serveur, et aucune requête n'est
 * « cross-origin » en développement.
 *
 * `VITE_API_BASE_URL` n'existe que pour un déploiement où le front est servi
 * par un autre hôte que l'API.
 */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? "";

/**
 * Empreinte de la construction en cours, affichée en bas de la navigation.
 *
 * Elle est posée par le Makefile au moment de construire l'image : un numéro qui
 * monte d'un à chaque commit, et l'empreinte courte qui dit lequel. C'est la
 * version du LOGICIEL, à ne pas confondre avec la version de grille tarifaire
 * (`rate_version`) que portent les packs et les écritures d'achat : celle-là est
 * une donnée métier, figée sur chaque achat, et elle ne bouge que lorsqu'on
 * publie de nouveaux tarifs.
 *
 * `dev` quand rien n'est posé, c'est-à-dire sous `npm run dev` : mieux vaut le
 * dire que d'afficher un numéro qui ne correspond à aucun commit.
 */
export const BUILD: string = import.meta.env.VITE_BUILD || "dev";
